module.exports = __webpack_public_path__ + "0dfd5820f6ddf9a042f7f11b35e1666d.png";